import styled from 'styled-components';

/* Sparkle glyph wrapper. Unlike WalletGlyph, the colour lives inside the SVG
   (its own gradient + inner-shadow glow), so this only normalises the inner
   svg's box so it drops into the center orb cleanly. */
export const Glyph = styled.span`
  display: inline-flex;

  svg {
    display: block;
  }
`;
